



















































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Product} from '../../models/Product'

@Component({
  components: {},
})
export default class ProductRowGrid extends Vue {
  @Prop() product: Product
  @Prop() onClickAddCart: Function

}

